import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import userService from '../../services/userService';

/**
 * Componente para editar un usuario específico
 * Actúa como un puente para redirigir a UserManagement con el ID del usuario a editar
 */
const UserEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        console.log('Intentando obtener usuario con ID:', id);

        // Obtener el usuario de la API
        const userData = await userService.getUserById(id);
        console.log('Usuario obtenido:', userData);

        if (!userData || !userData._id) {
          throw new Error('Datos de usuario inválidos');
        }

        setUser(userData);

        // Redirigir a la página de gestión de usuarios con un parámetro de consulta
        // Usamos setTimeout para asegurar que la redirección ocurra después de que React haya actualizado el estado
        setTimeout(() => {
          navigate(`/admin/users?edit=${id}`, {
            state: {
              user: userData,
              viewMode: false,
            },
            replace: true, // Usamos replace para evitar problemas con el historial de navegación
          });
        }, 100);
      } catch (error) {
        console.error('Error fetching user:', error);
        setError(
          'No se pudo cargar la información del usuario. ' + (error.message || 'Error desconocido'),
        );
        setLoading(false);
      }
    };

    if (id) {
      fetchUser();
    } else {
      setError('ID de usuario no válido');
      setLoading(false);
    }
  }, [id, navigate]);

  if (loading) {
    return (
      <AdminLayout title="Editar Usuario" subtitle="Cargando...">
        <div className="loading">Cargando información del usuario...</div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout title="Editar Usuario" subtitle="Error">
        <div className="error">{error}</div>
        <div className="mt-4">
          <button className="btn btn-primary" onClick={() => navigate('/admin/users')}>
            Volver a Gestión de Usuarios
          </button>
        </div>
      </AdminLayout>
    );
  }

  // Este return normalmente no se ejecutará porque el componente redirigirá antes
  return (
    <AdminLayout title="Editar Usuario" subtitle={user ? `Editando: ${user.name}` : 'Cargando...'}>
      <div className="redirecting">Redirigiendo a la página de gestión de usuarios...</div>
    </AdminLayout>
  );
};

export default UserEdit;
